<template>
  
</template>

<script>
export default {
    props: {
            sponsorship: Number
        },
        mounted(){
         //this.$store.dispatch('getStatuses');
        },
     }
</script>

